<template>
  <div class=" flex flex-row">
    <div class="w-12">
      <img src="../ics/avatar.svg" class="avatar" alt="avatar">
    </div>
    <div class="w-full">
      <div class="flex justify-between">
        <div class="ml-2 font-bold text-sm">
          @wonglok
        </div>
        <div class="ml-r text-gray-600 text-sm">
          2019-09-23 18:03
        </div>
      </div>

      <div class="pl-2">
        Friends making friends powerful one day at a time.
        Friends making friends powerful one day at a time.
        Friends making friends powerful one day at a time.
        Friends making friends powerful one day at a time.
        Friends making friends powerful one day at a time.
        Friends making friends powerful one day at a time.
        Friends making friends powerful one day at a time.
        Friends making friends powerful one day at a time.
        Friends making friends powerful one day at a time.
        Friends making friends powerful one day at a time.
      </div>

      <div class="mt-5 mb-5 border-b border-gray-500 pb-5 flex">
        <Reactions></Reactions>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Reactions: require('./Reactions.vue').default
  }
}
</script>

<style scoped>
.avatar{
  height: 37px;
}
</style>
